.year {
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selected {
  color: white;
  opacity: 1;
  background-color: var(--main-text);
}

.cell:hover:not([disabled], .selected) {
  background-color: #e7edff;
}
